import { render, staticRenderFns } from "./BaseDictList.vue?vue&type=template&id=772961ba&scoped=true"
import script from "./BaseDictList.vue?vue&type=script&lang=js"
export * from "./BaseDictList.vue?vue&type=script&lang=js"
import style0 from "./BaseDictList.vue?vue&type=style&index=0&id=772961ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772961ba",
  null
  
)

export default component.exports